@if (!isSubmitted) {
  <div class="be-btn-group be-btn-group--right">
    <button
      (click)="closeModal()"
      class="be-btn be-btn--small be-btn--alt-borderless dialog-alternate-close-button"
      type="button"
      [eevTrackClick]="AuthLinkType.PROFILE_CONFIRM_CANCEL"
      >
      Cancel
    </button>
    <app-be-button
      (click)="confirmChange()"
      size="xsmall-responsive"
      type="submit"
      id="saveProfileFormBtn"
      [isDisabled]="isSubmitting || isSubmitted"
      [isLoading]="isSubmitting"
      >
      Confirm
    </app-be-button>
  </div>
}
